<ng-container *ngIf="hideFilters">
  <mat-chip-list>
    <mat-chip *ngFor="let term of termsToRender" [selectable]="false" [removable]="true" (removed)="removeTerm(term)">
      <span class="odilo-icon">{{term.icon}}</span>
      <span>{{(term.label || term.term) | removeQuotes}}</span>
      <span matChipRemove class="odilo-icon close-icon">close</span>
    </mat-chip>
  </mat-chip-list>
</ng-container>

<button
  *ngIf="!hideExploreButton"
  mat-flat-button
  class="full-catalog__btn"
  [ngClass]="textDirection"
  (click)="explore()">
  {{'search.explore' | translate}}
  <span class="odilo-icon" aria-hidden="true">navigate_next</span>

  <span class="full-catalog__btn__bg">
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="48" viewBox="0 0 90 48">
      <path
        d="M1.52,48A48,48,0,0,1,16.3,0H29.23a40.56,40.56,0,0,0-20,48ZM90,48V12.79A48.31,48.31,0,0,0,79.7,0H66.77a40.56,40.56,0,0,1,20,48ZM57.44,48H40.32l-1.75-.84a3.63,3.63,0,0,1-1.73-1.73l-14.36-30a3.69,3.69,0,0,1,4.92-4.92l30,14.36a3.63,3.63,0,0,1,1.73,1.73L69.41,48H61.22L54.75,34.47l-8.28,8.28ZM41.25,37.53l8.28-8.28-15.88-7.6Z" />
    </svg>
  </span>
</button>

<button
  *ngIf="showLearningExperiencesButton"
  mat-flat-button
  class="learning-experiences__btn"
  [ngClass]="textDirection"
  (click)="exploreLearningExperiences()">
  {{ learningExperiencesButtonLabel }}
  <span class="odilo-icon" aria-hidden="true">navigate_next</span>

  <span class="learning-experiences__btn__bg">
    <svg xmlns="http://www.w3.org/2000/svg" width="90" height="48" viewBox="0 0 90 48">
      <path
        d="M1.52,48A48,48,0,0,1,16.3,0H29.23a40.56,40.56,0,0,0-20,48ZM90,48V12.79A48.31,48.31,0,0,0,79.7,0H66.77a40.56,40.56,0,0,1,20,48ZM57.44,48H40.32l-1.75-.84a3.63,3.63,0,0,1-1.73-1.73l-14.36-30a3.69,3.69,0,0,1,4.92-4.92l30,14.36a3.63,3.63,0,0,1,1.73,1.73L69.41,48H61.22L54.75,34.47l-8.28,8.28ZM41.25,37.53l8.28-8.28-15.88-7.6Z" />
    </svg>
  </span>
</button>
